import { THEME } from 'components/theme'

const DrawerStyles = {
  main: {
    width: '33%',
    top: 0,
    backgroundColor: THEME.brandBGLight
  },
  // Sub-views (Security, Drive backup, Data Security Checkup): a column so a screen can fill
  // the height left under the title bar without overflowing the drawer
  subView: {
    display: 'flex',
    flexDirection: 'column'
  },
  showText: {
    cursor: 'pointer',
    padding: '0 0 10px 20px',
    color: THEME.brandGreen,
    fontSize: '0.8rem',
    display: 'flex',
    alignItems: 'center'
  },
  whiteBackground: {
    backgroundColor: THEME.brandWhite
  },
  paneHeader: {
    background: THEME.brandBGMedium,
    fontWeight: 'bold',
    fontSize: '12px',
    padding: '8px 20px',
    color: THEME.brandBlack
  },
  // Header of an in-drawer sub page (back arrow + title), same metrics as the Drawer header
  subHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    color: THEME.brandBlack,
    borderBottom: `1px solid ${THEME.brandLightGrey}`,
    backgroundColor: THEME.brandWhite
  },
  subHeaderBack: {
    cursor: 'pointer'
  },
  subHeaderTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginLeft: '12px'
  },
  field: {
    margin: '16px 20px',
    position: 'relative'
  },
  panel: {
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: THEME.brandWhite,
    cursor: 'pointer'
  },
  manager: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 20px',
    borderBottom: `1px solid ${THEME.brandLightGrey}`,
    cursor: 'pointer',
    fontSize: 14
  },
  managerIcon: {
    marginLeft: 8,
    marginRight: 12
  },
  panelSeparator: {
    height: '1px',
    width: 'calc(100% - 40px)',
    transform: 'translateX(20px)',
    backgroundColor: THEME.brandLightGrey
  },
  panelSeparatorBig: {
    height: '8px',
    backgroundColor: THEME.brandBGLight
  },
  panelTitle: {
    marginLeft: '12px'
  },
  panelRight: {
    marginLeft: 'auto'
  },
  panelLeft: {
    fontSize: '20px',
    color: THEME.brandMediumGrey,
    marginRight: '12px'
  },
  red: {
    color: THEME.brandRed,
    fill: THEME.brandRed
  },
  deleteIcon: {
    color: THEME.brandRed,
    marginRight: '17px'
  },
  gpsIcon: {
    position: 'absolute',
    top: '36px',
    right: '12px',
    color: THEME.brandDarkGreen,
    cursor: 'pointer'
  },
  tallyIcon: {
    height: '15px',
    width: 'auto',
    marginRight: '12px'
  },
  settingTitle: {
    marginLeft: 12
  },
  managersSection: {
    padding: '0 16px'
  },
  managerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    cursor: 'pointer',
    borderBottom: `1px solid ${THEME.brandLightGrey}`
  },
  managerMobile: {
    color: THEME.brandMediumGrey,
    fontSize: 13
  },
  addManagerBtn: {
    marginTop: 12,
    background: 'none',
    border: 'none',
    color: THEME.brandGreen,
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    padding: 0
  }
}

export default DrawerStyles
